import { render, staticRenderFns } from "./ServicePc.vue?vue&type=template&id=37cded7c&scoped=true&"
import script from "./ServicePc.vue?vue&type=script&lang=js&"
export * from "./ServicePc.vue?vue&type=script&lang=js&"
import style0 from "./ServicePc.vue?vue&type=style&index=0&id=37cded7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37cded7c",
  null
  
)

export default component.exports